import React from 'react'
import healthcare1 from '../images/primecore1.png';
import healthcare2 from '../images/primecore2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function PrimeCore() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">PrimeCore</span> – Human Resource Management Software
                    </div>

                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Remente App Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">PrimeCore</span> – Human Resource Management Software
                        </h1>

                        <p className="mb-3 ps-1">
                            PrimeCore is an advanced HR management platform designed to centralize workforce operations, automate routine processes,
                            and enhance organizational efficiency. It empowers businesses to streamline employee lifecycle management, reduce manual workload,
                            and maintain accuracy across all HR functions.
                        </p>

                        <p className="mb-3 ps-1">
                            From attendance and payroll automation to recruitment workflows, performance tracking, and employee data management,
                            PrimeCore provides a fully integrated digital HR ecosystem. The platform helps organizations make informed decisions,
                            improve productivity, and create a seamless, compliant, and scalable human resource environment.
                        </p>




                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> PrimeCore
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            HR Automation Engine, Employee Lifecycle Management, Attendance & Payroll Automation, React, Node.js, Firebase,
                            REST APIs, Role-Based Access System, Real-Time HR Analytics Dashboard
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">Human Resource Management Software</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Developer, Automation Engineer, Data Analyst, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">5 Months</p>

                        <p className="mb-4 ps-3">
                            PrimeCore is a comprehensive HR management software built to simplify and automate end-to-end workforce operations.
                            The platform centralizes employee data, attendance, payroll, performance tracking, recruitment workflows, and internal
                            communication into one unified system. Designed for both small teams and large enterprises, PrimeCore enhances accuracy,
                            reduces manual administrative work, and gives organizations complete visibility into their HR processes.
                            With automation-driven workflows, smart analytics, and seamless module integration, PrimeCore enables businesses to
                            maintain compliance, boost productivity, and manage their workforce efficiently and intelligently.
                        </p>




                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Remente UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Mental Wellness Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We developed PrimeCore with a modern HR-first architecture focused on automation, accuracy, and role-based workforce
                            management. The platform centralizes key HR functions — including attendance, payroll, employee records, performance
                            reviews, recruitment, and leave management — into a unified digital ecosystem. Our backend ensures secure data handling,
                            real-time updates, and seamless integration between HR modules for smooth organizational workflows.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was designed to simplify everyday HR operations and provide a clean, intuitive interface for HR teams,
                            employees, and management. With easy navigation, automated process flows, and insightful dashboard visuals,
                            PrimeCore makes complex HR tasks effortless — enabling teams to manage workforce operations with speed, clarity,
                            and zero technical barriers.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Automated attendance tracking with biometric/API integrations</li>
                            <li className="mb-1">Smart payroll management with auto-salary calculation & tax deductions</li>
                            <li className="mb-1">Employee lifecycle management: onboarding to exit workflows</li>
                            <li className="mb-1">Performance management system with KPI tracking</li>
                            <li className="mb-1">Recruitment & applicant tracking with automated screening</li>
                            <li className="mb-1">Leave, shift & roster management with real-time approval flows</li>
                            <li className="mb-1">Role-based dashboards with real-time HR analytics and insights</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default PrimeCore